import { render, staticRenderFns } from "./FilterLotSize.vue?vue&type=template&id=648b0540&"
import script from "./FilterLotSize.vue?vue&type=script&lang=js&"
export * from "./FilterLotSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports